import { Action, createReducer, on } from '@ngrx/store';

import { FeatureFlagsEnum } from '../../constants/feature-flags.enum';
import { clearFeatureFlags, updateFeatureFlags } from '../actions/feature-flags.actions';

export interface Flag {
  name: FeatureFlagsEnum;
  status: boolean;
}

export type FeatureFlagsState = { [key: string]: boolean } | null;

const initialState: FeatureFlagsState = null;

const reducer = createReducer(
  initialState,
  on(updateFeatureFlags, (state: FeatureFlagsState, { payload }: { payload: Flag[] }) =>
    payload.reduce(
      (acc, flag) => {
        acc[flag.name] = flag.status;
        return acc;
      },
      {} as { [key: string]: boolean },
    ),
  ),
  on(clearFeatureFlags, () => null),
);

export function featureFlagsReducer(state: FeatureFlagsState | undefined, action: Action): FeatureFlagsState {
  return reducer(state, action);
}
